var bigLogo;

bigLogo = function() {
  var $, TweenLite, module, moduleName;
  $ = require('jquery');
  TweenLite = require("gsap");
  moduleName = 'big-logo';
  module = document.querySelector("." + moduleName);
  return $(module).each(function() {
    var A, Ggray, Ggreen, O, timeline1, timeline2, timeline3, timeline4;
    timeline1 = new TimelineLite();
    timeline2 = new TimelineLite();
    timeline3 = new TimelineLite();
    timeline4 = new TimelineLite();
    A = this.querySelector("." + moduleName + "__a");
    Ggreen = this.querySelector("." + moduleName + "__g-green");
    Ggray = this.querySelector("." + moduleName + "__g-gray");
    O = this.querySelector("." + moduleName + "__o");
    timeline1.from(A, 3, {
      opacity: 1,
      y: '-1600px',
      ease: Elastic.easeOut.config(1.3, 0.9)
    });
    timeline2.from(Ggreen, 2.5, {
      opacity: 1,
      y: '-1800px',
      rotation: "270",
      transformOrigin: "50% 50%",
      ease: Bounce.easeOut
    });
    timeline3.fromTo(Ggray, 2.3, {
      opacity: 1,
      y: '-1600px'
    }, {
      y: '500px',
      ease: Bounce.easeOut,
      delay: 0.3
    }).to(Ggray, 1, {
      y: '250px',
      ease: Bounce.easeOut
    });
    return timeline4.from(O, 1.5, {
      opacity: 1,
      x: '1100px',
      ease: Elastic.easeOut.config(1, 0.3),
      delay: 2.7
    });
  });
};

module.exports = bigLogo;
